import React from "react";
import SecondFeaturedServices from "./SecondFeaturedServices";
import ThirdFeaturedServices from "./ThirdFeaturedServices";
import { useSelector } from "react-redux";
import BoxDuoFeaturedServices from "./BoxDuoFeaturedServices";
import TripleStackFeaturedServices from "./TripleStackFeaturedServices";
import FirstFeaturedServices from "./FirstFeaturedServices";
import MasonryShowcaseFeaturedServices from "./MasonryShowcaseFeaturedServices";
import CleanGridFeaturedServices from "./CleanGridFeaturedServices";

function HomeSpecialitiesWrapper({ isData, setIsdata }) {
  const sitedata = useSelector((store) => store.global.loginData);
  return (
    <>
      {sitedata?.theme_specialities === "simple-info-box" ? (
        <SecondFeaturedServices setIsdata={setIsdata} />
      ) : sitedata?.theme_specialities === "card-triple-stack" ? (
        <TripleStackFeaturedServices setIsdata={setIsdata} />
      ) : sitedata?.theme_specialities === "clean-grid-gallery" ? (
        <CleanGridFeaturedServices setIsdata={setIsdata} />
      ) : sitedata?.theme_specialities === "masonry-showcase" ? (
        <MasonryShowcaseFeaturedServices setIsdata={setIsdata} />
      ) : sitedata?.theme_specialities === "info-box-duo" ? (
        <BoxDuoFeaturedServices setIsdata={setIsdata} />
      ) : sitedata?.theme_specialities === "time-line" ? (
        <FirstFeaturedServices setIsdata={setIsdata} />
      ) : (
        <ThirdFeaturedServices setIsdata={setIsdata} />
      )}
  {/* <SecondFeaturedServices setIsdata={setIsdata} /> */}
             
    </>
  );
}

export default HomeSpecialitiesWrapper;
